import { createAction } from '@/utility/actions';

import { CHARTS_GET_LIST, CHARTS_GET_PERIODS, CHARTS_CLEAN_LIST } from './_types.ts';

/**
 * getCharts
 * @param {{object}} params
 * @returns {{types: *, action: *}}
 */
export const getCharts = createAction(CHARTS_GET_LIST);

/**
 * Get charts periods
 * @param {number} partner_id
 * @param {object} params
 */
export const getChartsPeriods = createAction(CHARTS_GET_PERIODS);

export const cleanChartsList = createAction(CHARTS_CLEAN_LIST);

export default {
  getCharts,
  cleanChartsList,
  getChartsPeriods,
};
